<template>
  <div class="card">

    <div v-for="item of devices" :key="item.id">
      <div class="card__title">{{ item.title }}</div>

      <el-table
          style="width: 100%"
          class="zebra-table"
          :data="(item.info)"
          :show-header="false">
        <el-table-column
            prop="title"
            label="title">
        </el-table-column>
        <el-table-column
            align="right"
            class="zebra-table__value"
            label="value">
          <template scope="scope">
            <div class="badge" :style="{'background': scope.row.color === 'none' ? scope.row.color : scope.row.color}">
              {{ scope.row.value }}
            </div>
          </template>
        </el-table-column>
      </el-table>

    </div>
  </div>
</template>

<script>
export default {
  name: "DeviceItem",
  data() {
    return {}
  },
  props: {
    devices: {}
  },
  components: {},
  created() {

  },
  computed: {},
  methods: {
    toArray(data) {
      return Object.keys(data).map((key) => {
        return {
          title: key,
          value: data[key]
        }
      })

    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/zebra-table.scss";

.card {
  background: #FFFFFF;
  border-radius: 4px;

  padding: 0 8px 10px 8px;

  &__title {
    padding-top: 10px;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;

    letter-spacing: -0.005em;

    color: #111;
  }
}

.zebra-table {
  &__value {
    color: #111;

    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
  }
}

.badge {
  display: inline-block;
  padding: 5px 8px;
  border-radius: 4px;
  color: #111;
}
</style>
